<template>
  <article class="how-to-section" :id="'#section-' + sectionKey">
    <h2>{{ section.title }}</h2>
    <HowToItem
      v-for="(question, index) in section.questions"
      :key="'question-' + index + '-section-' + sectionKey"
      :question="question"
      :sectionKey="sectionKey"
    />
  </article>
</template>

<script>
import HowToItem from "@/components/Dashboard/HowTo/HowToItem";
export default {
  name: "HowToSection",
  components: { HowToItem },
  props: {
    section: {
      type: Object,
      required: true,
    },
    sectionKey: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="scss">
#app .how-to-section {
  padding: 1rem 0;
  margin-bottom: 3rem;
  h2 {
    font-family: "ForzaBold";
    margin-bottom: 2rem;
  }
}
</style>